/**
 * API backend access functions
 */
var win = window;
var $ = win.jQuery;
var BASE_URL = getOption('homeUrl');
var WAIT = Symbol();
/**
 * Get a default option, defined in Wordpress.
 * At the moment, it's simply getting it from window.siteOptions,
 * that's attached via localize_script in setup.php.
 * But in the future, it might be something more elaborate
 */
export function getOption(optionName) {
    return window.siteOptions[optionName];
}
/**
 * Register an event with Analytics and/or Facebook pixel, if found
 */
export function sendEvent(category, action, label, value) {
    if (value === void 0) { value = null; }
    var win = window;
    if ('ga' in win)
        win.ga('send', 'event', category, action, label, value);
    if ('fbq' in win)
        win.fbq('track', category + ' ' + action, { label: label, value: value });
    console.log('Registering event', category, action, label, value);
}
/**
 * Get the nonce from the /wp-nonce/<action> route.
 */
export function getNonce(action) {
    if (action === void 0) { action = 'wp_rest'; }
    if (!win.ladysternNonceCache)
        win.ladysternNonceCache = {};
    if (win.ladysternNonceCache[action])
        return new Promise(function (resolve, reject) {
            var interval = setInterval(function () {
                if (win.ladysternNonceCache[action] !== WAIT) {
                    resolve(win.ladysternNonceCache[action]);
                    clearInterval(interval);
                }
            }, 10);
        });
    else {
        win.ladysternNonceCache[action] = WAIT;
        return $.get(BASE_URL + '/wp-nonce/' + action).then(function (nonce) {
            win.ladysternNonceCache[action] = nonce;
            return nonce;
        });
    }
}
/**
 * Add to email. Note that since this is not specific to this API,
 * it uses a direct AJAX call to the Wordpress AJAX, rather than
 * using the REST API interface
 */
export function addToNewsletter(email) {
    return getNonce('ladystern-newsletter-nonce').then(function (nonce) {
        return $.ajax({
            url: getOption('ajaxUrl'),
            method: 'post',
            data: {
                email: email,
                type: 'mailchimp',
                action: 'ladystern_newsletter_add',
                nonce: nonce,
            },
            dataType: 'json',
        });
    });
}
